export function shouldIgnoreDoodleShortcut(target: EventTarget | null): boolean {
	if (!(target instanceof HTMLElement)) return false;

	return target.isContentEditable || target.closest('[contenteditable="true"]') !== null || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName);
}
